import React, { FormEvent, useState } from 'react';

import { useMutation } from '@apollo/react-hooks';
import { SignUp_Mutation } from '@netfront/gelada-react-shared';
import { useRouter } from 'next/router';

import { Input, Label } from 'components/Form';

import { AuthenticationForm } from './AuthenticationForm';

export function RegisterForm(): JSX.Element {
  const router = useRouter();

  const [email, setEmail] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const [createUser, { loading: isLoading, error }] = useMutation(SignUp_Mutation, {
    context: { clientName: 'auth' },
    onCompleted: () => {
      router.push('/register-success');
    },
  });

  const sendRequest = (e: FormEvent) => {
    e.preventDefault();

    alert('Registration disable, please contact an administrator.');
    return;

    const incompleteRegister = !firstname || !lastname || !email || !password || !passwordConfirm;

    if (incompleteRegister) {
      return;
    }

    createUser({
      variables: {
        user: { firstname, lastname },
        credential: { email, password },
      },
    });
  };

  const lazyRequest = { sendRequest, isLoading, error };

  return (
    <AuthenticationForm ctaName="Register" lazyRequest={lazyRequest}>
      <div className="l-flex">
        <div className="m-r w-50">
          <Label htmlFor="firstname">First name:</Label>
          <Input id="firstname" type="text" value={firstname} required onChange={({ target: { value } }) => setFirstname(value)} />
        </div>
        <div className="w-50">
          <Label htmlFor="lastname">Last name:</Label>
          <Input id="lastname" type="text" value={lastname} required onChange={({ target: { value } }) => setLastname(value)} />
        </div>
      </div>

      <Label htmlFor="email">Email:</Label>
      <Input id="email" type="email" value={email} required onChange={({ target: { value } }) => setEmail(value)} />

      <Label htmlFor="password">Password:</Label>
      <Input id="password" type="password" value={password} required onChange={({ target: { value } }) => setPassword(value)} />

      <Label htmlFor="passwordconfirm">Password confirm:</Label>
      <Input
        id="passwordconfirm"
        type="password"
        value={passwordConfirm}
        required
        onChange={({ target: { value } }) => setPasswordConfirm(value)}
      />
    </AuthenticationForm>
  );
}
